import type { HelpFile } from '../../types/help'
import { InboundConnectorDetailTestIds } from '../../../testids/InboundConnectorDetailTestIds'

export const inboundConnectorDetailHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [InboundConnectorDetailTestIds.inboundConnectorDetailPage]:
      'Inbound connector detail — target system, connector type, protocol configuration, schedule, and sync run history.',
    [InboundConnectorDetailTestIds.tabOverview]:
      'High-level overview of the connector: target system, connector type, schedule, and last sync result.',
    [InboundConnectorDetailTestIds.tabConfiguration]:
      'Protocol-specific configuration for this inbound connector. Browse Connection, Reconciliation, and Operations sub-pages.',
    [InboundConnectorDetailTestIds.tabSyncRuns]:
      'Recent synchronisation runs for this connector: start and end times, record counts, and outcomes.',
    [InboundConnectorDetailTestIds.btnDelete]:
      'Delete this inbound connector. This action cannot be undone.',
    [InboundConnectorDetailTestIds.btnTestConnection]:
      'Test connectivity to the source system using the current configuration.',
    [InboundConnectorDetailTestIds.btnToggleEnabled]:
      'Enable or disable this inbound connector. Disabled connectors do not run on schedule.',
    [InboundConnectorDetailTestIds.deleteConfirmDialog]:
      'Confirm deletion of this inbound connector. This action cannot be undone.',
    [InboundConnectorDetailTestIds.detailTabs]:
      'Switch between overview, configuration, and sync run views.',
    [InboundConnectorDetailTestIds.testResultDialog]:
      'Result of the connectivity test — success or the underlying error.',
    [InboundConnectorDetailTestIds.lastSyncCreatedCount]:
      'Number of records created during the most recent sync run.',
    [InboundConnectorDetailTestIds.lastSyncUpdatedCount]:
      'Number of records updated during the most recent sync run.',
    [InboundConnectorDetailTestIds.lastSyncErroredCount]:
      'Number of records that errored during the most recent sync run.',
  },
}
